/* istanbul ignore file */

import { css } from 'styled-components';

export const hideScrollbar = css`
  ${/* for Internet Explorer, Edge */ ''}
  -ms-overflow-style: none;
  ${/* for Firefox */ ''}
  scrollbar-width: none;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    ${/* for Chrome, Safari, and Opera */ ''}
    display: none;
  }
`;
